module.exports = __webpack_public_path__ + "img/project-cover6.305ccc32.png";